var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"PicTagTitle material-title overflow-one",attrs:{"href":_vm.picItemInfo.link_url,"target":"_blank","title":_vm.picItemInfo.title}},[_vm._v(_vm._s(_vm.picItemInfo.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }